import script from "./CaseManagersTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./CaseManagersTable.vue?vue&type=script&lang=ts&setup=true"

import "./CaseManagersTable.vue?vue&type=style&index=0&id=0937ed4f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0937ed4f"]])

export default __exports__